import { SiteFeature } from '@gn-audio/core/api/site-settings/enums';
import { isSiteFeatureEnabled } from '@gn-audio/core/common/utilities';

export const canBootstrapUip = async (): Promise<boolean> => {
  return await isSiteFeatureEnabled(SiteFeature.TopMenuUipEnabled);
};
